<template>
    <div style="width:100%">
      <b-input-group>
          <b-input-group-prepend>
              <div class="input-group-text">
                  <i :class="selected.icon"></i>
              </div>
          </b-input-group-prepend>
          <b-input-group-prepend>
            <b-dropdown id="ddown1" variant="info">
              <b-dropdown-item v-for="option in options" :key="option.id" @click="selected = option">{{option.text}}</b-dropdown-item>
              <!-- <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item>Something else here...</b-dropdown-item>
              <b-dropdown-item disabled>Disabled action</b-dropdown-item> -->
            </b-dropdown>
          </b-input-group-prepend>
          <input v-show="selected.id === 1" ref="inputfield" type="text" class="form-control" v-model="text" @keyup.enter="search" :disabled="selected.id === 2">
          <input v-show="selected.id !== 1" type="text" class="form-control" v-model="text" @keyup.enter="search" :disabled="selected.id === 2">
          <!-- <b-form-input v-model="text" @keyup.enter="search"></b-form-input> -->
          <b-input-group-append>
              <b-btn v-if="!loading" variant="info" @click="search">Buscar</b-btn>
              <b-btn v-else variant="info" disabled>
                <i class="fa fa-spinner fa-pulse" style="padding-left: 0em;"></i>
              </b-btn>
          </b-input-group-append>
      </b-input-group>

      <b-modal class="fixedModal" ref="zeusModal" size="lg" id="modal1" title="Dirección Zeus" centered :hide-footer="true">
        <div>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Provincia">
                  <b-form-select v-model="zeus.provincia" :options="provincia_options" class="mb-3" text-field="nombre_provincia_ine" value-field="zeus_codigo_provincia_ine" :disabled="provincia_options.length===0"/>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Municipio">
                  <b-form-select v-model="zeus.municipio" :options="municipio_options" class="mb-3" text-field="nombre_municipio_ine" value-field="zeus_codigo_municipio_ine" :disabled="municipio_options.length===0"/>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Población">
                  <b-form-select v-model="zeus.poblacion" :options="poblacion_options" class="mb-3" text-field="entity_name" value-field="zeus_codigo_poblacion_ine" :disabled="poblacion_options.length===0"/>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form>
                <!-- <b-form-group style="font-size: 1rem;" label="Nombre vía">
                  <b-form-input v-model="zeus.nombre"></b-form-input>
                </b-form-group> -->
                <b-form-group style="font-size: 1rem;" label="Nombre vía" class="autocomplete">
                    <b-form-input autocomplete="off" @input="loadNames" name="Nombre vía" v-model="zeus.nombre"></b-form-input>
                    <div v-if="show_names" class="autocomplete-items">
                      <div @click="setElement(element, 'nombre')" v-for="(element, index) in names_suggestions" v-bind:key="index">
                        {{element.street_type.name_type}} {{element.street_name}} ({{element.postal_code_address}})
                        <!-- <strong>Sp</strong>ain<input type="hidden" value="Spain"> -->
                      </div>
                    </div>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <!-- <b-form-group style="font-size: 1rem;" label="Número">
                  <b-form-input v-model="zeus.numero"></b-form-input>
                </b-form-group> -->
                <b-form-group style="font-size: 1rem;" label="Número" class="autocomplete">
                    <b-form-input autocomplete="off" @input="loadNumbers" name="Número" v-model="zeus.numero"></b-form-input>
                    <div v-if="show_numbers" class="autocomplete-items">
                      <div @click="setElement(element, 'numero')" v-for="(element, index) in number_suggestions" v-bind:key="index">
                        {{element}}
                        <!-- <strong>Sp</strong>ain<input type="hidden" value="Spain"> -->
                      </div>
                    </div>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Anexo">
                  <b-form-input v-model="zeus.anexo"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: right;">
              <!-- <b-button>Limpiar</b-button> -->
              <b-button @click="hideZeusModal">Cancelar</b-button>
              <b-button v-if="!loading" @click="searchZeus">Buscar</b-button>
              <b-button v-else disabled>
                <i class="fa fa-spinner fa-pulse" style="padding-left: 0em;"></i>
              </b-button>
            </b-col>
            <br><br>
          </b-row>
        </div>
      </b-modal>
      <b-modal id="generic" ref="genericmodal" ok-only>
        <p class="my-4">{{textgeneric}}</p>
      </b-modal>
    </div>
</template>

<script>
import EventBus from '../Modules/EventBus.vue';

var debounce = require('debounce');

export default {
  name: 'SearchBar',
  data () {
    return {
      text: '',
      autocomplete: null,
      textgeneric: '',
      loading: false,
      selected: {id: 1, text: 'Dirección Google', icon: 'fa fa-map'},
      provincia_options: [],
      municipio_options: [],
      poblacion_options: [],
      names_suggestions: [],
      number_suggestions: [],
      show_names: false,
      show_numbers: false,
      clickHappened: false,
      zeus: {
        provincia: '',
        municipio: '',
        poblacion: '',
        nombre: '',
        numero: '',
        anexo: '',
        street_id: null
      },
      options: [
        {id: 1, text: 'Dirección Google', icon: 'fa fa-map'},
        {id: 2, text: 'Dirección Zeus', icon: 'fa fa-building'},
        {id: 3, text: 'CIDI residencial', icon: 'fa fa-university'},
        {id: 4, text: 'Área de lote', icon: 'fa fa-university'},
        {id: 5, text: 'Código planta GLP', icon: 'fa fa-university'},
        {id: 12, text: 'Código del vendedor GLP', icon: 'fa fa-university'},
        {id: 6, text: 'Código postal', icon: 'fa fa-university'},
        {id: 7, text: 'Comercios google', icon: 'fa fa-university'},
        {id: 8, text: 'Coordenadas WGS84', icon: 'fa fa-university'},
        {id: 9, text: 'IDI comercial', icon: 'fa fa-university'},
        {id: 13, text: 'IDI caldera', icon: 'fa fa-fire'},
        {id: 10, text: 'Nombre comercial', icon: 'fa fa-university'},
        {id: 11, text: 'Parcela catastral', icon: 'fa fa-file-text'}
      ]
    };
  },
  methods: {
    loadNames: debounce(function (value) {
      if (value && !this.clickHappened) {
        this.zeus.street_id = null;
        this.$http.get('streets/', {params: {
          direccion__icontains: value.toUpperCase(),
          zeus_codigo_provincia_ine: this.zeus.provincia,
          zeus_codigo_municipio_ine: this.zeus.municipio,
          zeus_codigo_poblacion_ine: this.zeus.poblacion
        }}).then(result => {
          this.names_suggestions = result.data.results;
          this.show_names = true;
        });
      } else {
        this.show_names = false;
      }
    }, 250),
    loadNumbers: debounce(function (value) {
      if (value && !this.clickHappened) {
        this.$http.get('gco_fincas_zeus/', {params: {
          street_id: this.zeus.street_id,
          building_number__icontains: value,
          ordering: 'building_number',
          not_paginated: true}
        }).then(result => {
          var s = new Set(result.data.map(e => e.building_number));
          this.number_suggestions = Array.from(s);
          this.show_numbers = true;
        });
      } else {
        this.show_numbers = false;
      }
    }, 250),
    setElement: function (value, type) {
      if (type === 'nombre') {
        if (value.street_name) {
          this.$set(this.zeus, 'nombre', value.street_name);
          this.$set(this.zeus, 'street_id', value.id);
        }
        if (value.zeus_codigo_poblacion_ine) {
          var p = this.poblacion_options.find(e => e.zeus_codigo_poblacion_ine === value.zeus_codigo_poblacion_ine);
          this.$set(this.zeus, 'poblacion', p.zeus_codigo_poblacion_ine);
        }
        this.show_names = false;
      } else if (type === 'numero') {
        this.$set(this.zeus, 'numero', value);
        this.show_numbers = false;
      }
      this.clickHappened = true;

      var th = this;
      setTimeout(() => {
        th.clickHappened = false;
      }, 400);
    },
    openZeusModal: function () {
      this.$refs.zeusModal.show();
    },
    search: function () {
      this.loading = true;
      var th = this;

      if (this.selected.id === 1) {
        if (this.text === undefined) {
          this.text = this.autocomplete.getPlace().name;
        }
        self.$.ajax({
          url: 'https://maps.googleapis.com/maps/api/geocode/json',
          type: 'GET',
          data: {key: process.env.GOOGLE_MAPS_API_KEY, address: this.text + ', españa'}
        }).done(function (response) {
          if (response.results.length > 0) {
            var bbox = response.results[0].geometry;
            if (bbox.bounds) {
              bbox = bbox.bounds;
              bbox = [[bbox.northeast.lat, bbox.northeast.lng], [bbox.southwest.lat, bbox.southwest.lng]];
              th.$parent.$parent.$parent.fitBounds(bbox);
            } else if (bbox.location) {
              bbox = bbox.location;
              bbox = [bbox.lat, bbox.lng];
              th.$parent.$parent.$parent.setView(bbox);
            }
            th.$parent.$parent.$parent.setSearchMarker(response.results[0].geometry.location, response.results[0].formatted_address);
          } else {
            // alert('No se ha encontrado nada con ese nombre.')
            th.textgeneric = 'No se ha encontrado nada con ese nombre.';
            th.$refs.genericmodal.show();
          }
          th.loading = false;
        });
      } else if (this.selected.id === 2) {
        this.loading = false;
        this.openZeusModal();
      } else if (this.selected.id === 3) {
        this.$http.get('residencial/cidi/', {params: {extendidaresidencial__supply_id: this.text}}).then(result => {
          if (result.data.results.length > 0) {
            var res = result.data.results[0];
            var point = JSON.parse(res.geom);

            var title = this.text;
            var bbox = [point.coordinates[1], point.coordinates[0]];

            this.$parent.$parent.$parent.setView(bbox);
            this.$parent.$parent.$parent.setSearchMarker(bbox, title);
            this.hideZeusModal();

            this.loading = false;
          } else {
            // alert('No se ha encontrado ningún resultado')
            this.textgeneric = 'No se ha encontrado ningún resultado';
            this.$refs.genericmodal.show();
            this.loading = false;
          }
        });
      } else if (this.selected.id === 4) {
        this.$http.get('seccion_censal/', {params: {codigo_seccion_censal: this.text}}).then(result => {
          if (result.data.results.length > 0) {
            var res = result.data.results[0];
            var pol = JSON.parse(res.geom);

            var title = this.text;

            this.$parent.$parent.$parent.setBounds(pol);
            this.$parent.$parent.$parent.setSearchPolygon(pol, title);
            this.hideZeusModal();

            this.loading = false;
          } else {
            // alert('No se ha encontrado ningún resultado')
            this.textgeneric = 'No se ha encontrado ningún resultado';
            this.$refs.genericmodal.show();
            this.loading = false;
          }
        });
      } else if (this.selected.id === 5) {
        this.$http.get('planta_gasificacion/', {params: {codigo_planta: this.text}}).then(result => {
          if (result.data.results.length > 0) {
            var res = result.data.results[0];
            var point = JSON.parse(res.geom);

            var title = this.text;
            var bbox = [point.coordinates[1], point.coordinates[0]];

            this.$parent.$parent.$parent.setView(bbox);
            this.$parent.$parent.$parent.setSearchMarker(bbox, title);
            this.hideZeusModal();

            this.loading = false;
          } else {
            // alert('No se ha encontrado ningún resultado')
            this.textgeneric = 'No se ha encontrado ningún resultado';
            this.$refs.genericmodal.show();
            this.loading = false;
          }
        });
      } else if (this.selected.id === 12) {
        this.$http.get('planta_gasificacion/', {params: {descripcion__icontains: this.text}}).then(result => {
          if (result.data.results.length > 0) {
            var res = result.data.results[0];
            var point = JSON.parse(res.geom);

            var title = res.descripcion;
            var bbox = [point.coordinates[1], point.coordinates[0]];

            this.$parent.$parent.$parent.setView(bbox);
            this.$parent.$parent.$parent.setSearchMarker(bbox, title);
            this.hideZeusModal();

            this.loading = false;
          } else {
            // alert('No se ha encontrado ningún resultado')
            this.textgeneric = 'No se ha encontrado ningún resultado';
            this.$refs.genericmodal.show();
            this.loading = false;
          }
        });
      } else if (this.selected.id === 6) {
        this.$http.get('codigo_postal/', {params: {codigo_postal: this.text}}).then(result => {
          if (result.data.results.length > 0) {
            var res = result.data.results[0];
            var pol = JSON.parse(res.geom);

            var title = this.text;

            this.$parent.$parent.$parent.setBounds(pol);
            this.$parent.$parent.$parent.setSearchPolygon(pol, title);
            this.hideZeusModal();

            this.loading = false;
          } else {
            // alert('No se ha encontrado ningún resultado')
            this.textgeneric = 'No se ha encontrado ningún resultado';
            this.$refs.genericmodal.show();
            this.loading = false;
          }
        });
      } else if (this.selected.id === 7) {
        this.$http.get('places/', {params: {text: this.text}}).then(result => {
          if (result.body.candidates.length > 0) {
            var comercial = result.body.candidates[0];

            var title = comercial.name;
            var bbox = [comercial.geometry.location.lat, comercial.geometry.location.lng];

            this.$parent.$parent.$parent.setView(bbox);
            this.$parent.$parent.$parent.setSearchMarker(bbox, title);
            this.hideZeusModal();

            this.loading = false;
          } else {
            // alert('No se ha encontrado ningún resultado')
            this.textgeneric = 'No se ha encontrado ningún resultado';
            this.$refs.genericmodal.show();
            this.loading = false;
          }
        });

        // self.$.ajax({
        //   url: 'https://maps.googleapis.com/maps/api/place/findplacefromtext/json',
        //   type: 'GET',
        //   crossDomain: true,
        //   dataType: 'jsonp',
        //   data: {
        //     key: process.env.GOOGLE_MAPS_API_KEY,
        //     input: this.text + ', españa',
        //     language: 'es',
        //     inputtype: 'textquery',
        //     fields: 'name,geometry'
        //   }
        // }).done(function (response) {
        //   if (response.results.length > 0) {
        //     var bbox = response.results[0].geometry
        //     if (bbox.bounds) {
        //       bbox = bbox.bounds
        //       bbox = [[bbox.northeast.lat, bbox.northeast.lng], [bbox.southwest.lat, bbox.southwest.lng]]
        //       th.$parent.$parent.$parent.fitBounds(bbox)
        //     } else if (bbox.location) {
        //       bbox = bbox.location
        //       bbox = [bbox.lat, bbox.lng]
        //       th.$parent.$parent.$parent.setView(bbox)
        //     }
        //     th.$parent.$parent.$parent.setSearchMarker(response.results[0].geometry.location, response.results[0].formatted_address)
        //   } else {
        //     alert('No se ha encontrado nada con ese nombre.')
        //   }
        //   th.loading = false
        // })
      } else if (this.selected.id === 8) {
        self.$.ajax({
          url: 'https://maps.googleapis.com/maps/api/geocode/json',
          type: 'GET',
          data: {
            key: process.env.GOOGLE_MAPS_API_KEY,
            latlng: this.text,
            result_type: 'street_address',
            language: 'es'
          }}).done(function (response) {
          var bbox = [th.text.split(',')[0], th.text.split(',')[1]];
          if (response.results.length > 0) {
            th.$parent.$parent.$parent.setView(bbox);
            th.$parent.$parent.$parent.setSearchMarker(bbox, response.results[0].formatted_address);
          } else {
            // alert('No se ha encontrado nada con ese nombre.')
            // th.textgeneric = 'No se ha encontrado nada con ese nombre.';
            // th.$refs.genericmodal.show();

            th.$parent.$parent.$parent.setView(bbox);
            var markerText = 'Coordenadas: ' + th.text;
            th.$parent.$parent.$parent.setSearchMarker(bbox, markerText);
          }
          th.loading = false;
        });
      } else if (this.selected.id === 9) {
        this.$http.get('comercial3/' + this.text + '/').then(result => {
          var comercial = result.data;
          var point = JSON.parse(comercial.geom);

          var title = this.text;
          var bbox = [point.coordinates[1], point.coordinates[0]];

          this.$parent.$parent.$parent.setView(bbox);
          this.$parent.$parent.$parent.setSearchMarker(bbox, title);
          this.hideZeusModal();

          this.loading = false;
        }, error => {
          console.log(error);
          // alert('No se ha encontrado nada con ese nombre.')
          this.textgeneric = 'No se ha encontrado nada con ese IDI.';
          this.$refs.genericmodal.show();
          this.loading = false;
        });
      } else if (this.selected.id === 10) {
        this.$http.get('comercial3/', {params: {nombre__icontains: this.text}}).then(result => {
          if (result.data.results.length > 0) {
            var comercial = result.data.results[0];
            var point = JSON.parse(comercial.geom);

            var title = comercial.nombre;
            var bbox = [point.coordinates[1], point.coordinates[0]];

            this.$parent.$parent.$parent.setView(bbox);
            this.$parent.$parent.$parent.setSearchMarker(bbox, title);
            this.hideZeusModal();

            this.loading = false;
          } else {
            // alert('No se ha encontrado ningún resultado')
            this.textgeneric = 'No se ha encontrado ningún resultado';
            this.$refs.genericmodal.show();
            this.loading = false;
          }
        });
      } else if (this.selected.id === 11) {
        var params = {
          Provincia: '',
          Municipio: '',
          RC: this.text,
          SRS: 'EPSG:4326'
        };
        var url = 'http://ovc.catastro.meh.es/ovcservweb/ovcswlocalizacionrc/ovccoordenadas.asmx/Consulta_CPMRC';

        this.$http.post('refcatastral/', {'url': url + self.L.Util.getParamString(params)}).then(value => {
          if (value.body.error) {
            console.error('Error');
          } else {
            var bbox = [parseFloat(value.body.y), parseFloat(value.body.x)];
            var title = this.text;
            this.$parent.$parent.$parent.setView(bbox);
            this.$parent.$parent.$parent.setSearchMarker(bbox, title);
          }
        });
        this.loading = false;
      } else if (this.selected.id === 13) {
        this.$http.get('caldera3/' + this.text + '/').then(result => {
          var caldera = result.data;
          var point = JSON.parse(caldera.geom);

          var title = this.text;
          var bbox = [point.coordinates[1], point.coordinates[0]];

          this.$parent.$parent.$parent.setView(bbox);
          this.$parent.$parent.$parent.setSearchMarker(bbox, title);
          this.hideZeusModal();

          this.loading = false;
        }, error => {
          console.log(error);
          // alert('No se ha encontrado nada con ese nombre.')
          this.textgeneric = 'No se ha encontrado nada con ese IDI.';
          this.$refs.genericmodal.show();
          this.loading = false;
        });
      }
    },
    searchZeus: function () {
      this.$http.get('gco_fincas_zeus/', {params: {street_id: this.zeus.street_id, building_number: this.zeus.numero}}).then(result => {
        if (result.data.results.length > 0) {
          var point = result.data.results[0];
          point.geom = JSON.parse(point.geom);

          var bbox = [point.geom.coordinates[1], point.geom.coordinates[0]];

          var calle = this.names_suggestions.find(e => e.id === this.zeus.street_id);
          var poblacion = this.poblacion_options.find(e => e.zeus_codigo_poblacion_ine === calle.zeus_codigo_poblacion_ine);
          var title = calle.street_type.name_type + ' ' + calle.street_name + ' ' + this.zeus.numero + ', ' + poblacion.entity_name;

          this.$parent.$parent.$parent.setView(bbox);
          this.$parent.$parent.$parent.setSearchMarker(bbox, title);
          this.hideZeusModal();
        } else {
          // alert('No se ha encontrado ningún resultado')
          this.textgeneric = 'No se ha encontrado ningún resultado';
          this.$refs.genericmodal.show();
        }
        this.loading = false;
      });
    },
    hideZeusModal: function () {
      this.$refs.zeusModal.hide();
    },
    loadProvincia: function () {
      this.$http.get('geoprovincia/', {params: {not_paginated: true, ordering: 'nombre_provincia_ine'}}).then(result => {
        this.provincia_options = [{entity_name: '', nombre_provincia_ine: ''}].concat(result.data);
      });
    },
    loadMunicipios: function () {
      this.$http.get('geomunicipio/', {params: {not_paginated: true, ordering: 'nombre_municipio_ine', zeus_codigo_provincia_ine: this.zeus.provincia}}).then(result => {
        this.municipio_options = [{entity_name: '', nombre_municipio_ine: ''}].concat(result.data);
      });
    },
    loadPoblaciones: function () {
      this.$http.get('geopoblacion/', {params: {not_paginated: true, ordering: 'entity_name', zeus_codigo_municipio_ine: this.zeus.municipio}}).then(result => {
        this.poblacion_options = [{entity_name: '', zeus_codigo_poblacion_ine: ''}].concat(result.data);
      });
    },
    initAutocomplete: function () {
      this.autocomplete = new self.google.maps.places.Autocomplete(this.$refs.inputfield);

      var th = this;
      this.autocomplete.addListener('place_changed', function () {
        var place = th.autocomplete.getPlace();
        th.text = place.formatted_address;

        th.search();

        // infowindow.close();
        // marker.setVisible(false);
        // var place = autocomplete.getPlace();
        // if (!place.geometry) {
        //   // User entered the name of a Place that was not suggested and
        //   // pressed the Enter key, or the Place Details request failed.
        //   window.alert("No details available for input: '" + place.name + "'");
        //   return;
        // }

        // // If the place has a geometry, then present it on a map.
        // if (place.geometry.viewport) {
        //   map.fitBounds(place.geometry.viewport);
        // } else {
        //   map.setCenter(place.geometry.location);
        //   map.setZoom(17);  // Why 17? Because it looks good.
        // }
        // marker.setPosition(place.geometry.location);
        // marker.setVisible(true);

        // var address = '';
        // if (place.address_components) {
        //   address = [
        //     (place.address_components[0] && place.address_components[0].short_name || ''),
        //     (place.address_components[1] && place.address_components[1].short_name || ''),
        //     (place.address_components[2] && place.address_components[2].short_name || '')
        //   ].join(' ');
        // }

        // infowindowContent.children['place-icon'].src = place.icon;
        // infowindowContent.children['place-name'].textContent = place.name;
        // infowindowContent.children['place-address'].textContent = address;
        // infowindow.open(map, marker);
      });
    }
  },
  mounted: function () {
    // this.selected = this.options[0]
    this.loadProvincia();
    EventBus.$on('google-maps-api-loaded', this.initAutocomplete);
  },
  beforeDestroy () {
    EventBus.$off('google-maps-api-loaded', this.initAutocomplete);
  },
  watch: {
    selected: function () {
      this.text = '';
      if (this.selected.id === 2) {
        this.openZeusModal();
      }
    },
    'zeus.provincia': function () {
      if (this.zeus.provincia === '') {
        this.municipio_options = [];
      } else {
        this.loadMunicipios();
      }
    },
    'zeus.municipio': function () {
      if (this.zeus.municipio === '') {
        this.poblacion_options = [];
      } else {
        this.loadPoblaciones();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SearchBar.vue